module.exports = __webpack_public_path__ + "img/user-bg-default.629fa546.jpg";